export const HEADING_FONT = `BiankaScript, cursive;`;
export const HEADING_ALTERNATIVE = `'Pinyon Script', cursive;`;
export const BODY_FONT = `'Philosopher', sans-serif;`;
export const BODY_ALTERNATIVE = `'Mrs Saint Delafield', cursive;`;

